module.exports = __webpack_public_path__ + "img/saba_matza_no.9eb912eb.png";